/*
 * COZZYDEPT. Relaunch v3: Interaktionen
 * Flüssiges Scrollen, Einblenden, Zähler, Kachel-Neigung, 3D-Intro und Info-Punkte,
 * 3D-Drehung beim Scrollen, Produkt-Navigation, Galerie, Karussell.
 */
(() => {
  const root = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);
  const animate = root.classList.contains('cz-anim');
  window.czReady = true;

  const headerOffset = () =>
    (parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 64) + 52;

  /* Seit Horizon 4.3 scrollt ab 990 px Breite nicht mehr das Fenster, sondern .page-wrapper
     (html und body haben dann overflow: hidden). Alles Scroll-Abhängige richtet sich danach. */
  const pageWrapper = document.querySelector('.page-wrapper');
  const scroller = () =>
    pageWrapper &&
    pageWrapper.scrollHeight > pageWrapper.clientHeight + 1 &&
    /(auto|scroll)/.test(getComputedStyle(pageWrapper).overflowY)
      ? pageWrapper
      : null;
  const scrollTopNow = () => {
    const sc = scroller();
    return sc ? sc.scrollTop : window.scrollY;
  };

  /* Flüssiges Scrollen mit Maus und Trackpad (Touch bleibt nativ) */
  let lenis = null;
  if (window.Lenis && finePointer && !reduce && !designMode) {
    const sc = scroller();
    lenis = new window.Lenis({
      ...(sc ? { wrapper: sc, content: sc.querySelector('main') || sc, eventsTarget: sc } : {}),
      lerp: 0.1,
      autoRaf: true,
      autoToggle: true,
      allowNestedScroll: true,
      anchors: { offset: -headerOffset() },
    });
    window.czLenis = lenis;
  }
  const scrollToY = (y) => {
    if (lenis && !lenis.isStopped) lenis.scrollTo(y, { duration: 1.2 });
    else (scroller() || window).scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
  };

  /* Einblenden beim Scrollen + Zähler */
  const countUp = (el) => {
    const to = Number(el.dataset.czCount);
    if (!to || reduce) return;
    const duration = 1400;
    const start = performance.now();
    const tick = (now) => {
      const k = Math.min(1, (now - start) / duration);
      el.textContent = String(Math.round(to * (1 - Math.pow(1 - k, 3))));
      if (k < 1) requestAnimationFrame(tick);
    };
    el.textContent = '0';
    requestAnimationFrame(tick);
  };

  const revealEls = document.querySelectorAll('[data-cz-reveal]');
  if (animate && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          entry.target.querySelectorAll('[data-cz-count]').forEach(countUp);
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px' }
    );
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-in'));
  }

  /* Kacheln neigen sich leicht zur Maus */
  if (!reduce && finePointer) {
    document.querySelectorAll('[data-cz-tilt]').forEach((el) => {
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        el.style.setProperty('--rx', `${(-y * 4).toFixed(2)}deg`);
        el.style.setProperty('--ry', `${(x * 5).toFixed(2)}deg`);
        el.style.setProperty('--mx', `${((x + 0.5) * 100).toFixed(1)}%`);
        el.style.setProperty('--my', `${((y + 0.5) * 100).toFixed(1)}%`);
      });
      el.addEventListener('pointerleave', () => {
        el.style.setProperty('--rx', '0deg');
        el.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* 3D-Intro: Kamera gleitet beim Laden sanft in die Startansicht */
  document.querySelectorAll('model-viewer[data-cz-intro]').forEach((viewer) => {
    if (reduce || viewer.loaded) return;
    const finalOrbit = viewer.getAttribute('camera-orbit');
    const finalDecay = viewer.getAttribute('interpolation-decay') || '80';
    viewer.setAttribute('camera-orbit', viewer.dataset.czIntro);
    viewer.addEventListener(
      'load',
      () => {
        if (viewer.jumpCameraToGoal) viewer.jumpCameraToGoal();
        viewer.setAttribute('interpolation-decay', '260');
        requestAnimationFrame(() => viewer.setAttribute('camera-orbit', finalOrbit));
        setTimeout(() => viewer.setAttribute('interpolation-decay', finalDecay), 2600);
      },
      { once: true }
    );
  });

  /* Info-Punkte am Modell: antippen öffnet, ein zweites Mal schliesst */
  document.addEventListener('click', (event) => {
    const spot = event.target.closest('.cz-hotspot');
    document.querySelectorAll('.cz-hotspot.is-open').forEach((s) => {
      if (s !== spot) s.classList.remove('is-open');
    });
    if (spot) spot.classList.toggle('is-open');
  });

  /* 3D-Shirt dreht sich beim Scrollen */
  document.querySelectorAll('[data-cz-spin]').forEach((section) => {
    if (reduce) return;
    const track = section.querySelector('.cz-spin__track');
    const stage = section.querySelector('.cz-spin__stage');
    const viewer = section.querySelector('model-viewer');
    const steps = [...section.querySelectorAll('.cz-spin__step')];
    const dots = [...section.querySelectorAll('.cz-spin__dot')];
    const pitch = section.dataset.czPitch || '82deg';
    if (!track || !stage || !viewer || !steps.length) return;

    section.classList.add('is-scroll');
    viewer.removeAttribute('camera-controls');
    viewer.removeAttribute('auto-rotate');

    // Jeder Schritt hat einen Zielwinkel (data-angle) und liegt an einer festen Stelle im
    // Abschnitt (erster ganz oben, letzter ganz unten). Dazwischen dreht sich das Shirt
    // gleichmässig mit dem Scrollen, mit einer kurzen Pause an jedem Schritt.
    const angles = steps.map((s, i) => Number(s.dataset.angle ?? (i * 360) / steps.length));
    const ease = (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);
    const HOLD = 0.12;
    const angleAt = (p) => {
      const n = steps.length;
      if (n < 2) return angles[0];
      const x = p * (n - 1);
      const i = Math.min(n - 2, Math.floor(x));
      const t = Math.min(1, Math.max(0, (x - i - HOLD) / (1 - 2 * HOLD)));
      return angles[i] + (angles[i + 1] - angles[i]) * ease(t);
    };
    const stepAt = (p) => Math.min(steps.length - 1, Math.round(p * (steps.length - 1)));
    const stickyTop = () => parseFloat(getComputedStyle(stage).top) || 0;
    const span = () => track.offsetHeight - stage.offsetHeight;
    const progress = () => {
      const r = track.getBoundingClientRect();
      return Math.min(1, Math.max(0, (stickyTop() - r.top) / (span() || 1)));
    };

    let lastStep = -1;
    let lastAngle = null;
    let queued = false;
    const update = () => {
      queued = false;
      const p = progress();
      const angle = Math.round(angleAt(p) * 10) / 10;
      if (angle !== lastAngle) {
        viewer.setAttribute('camera-orbit', `${angle}deg ${pitch} auto`);
        lastAngle = angle;
      }
      const step = stepAt(p);
      if (step !== lastStep) {
        steps.forEach((s, i) => s.classList.toggle('is-active', i === step));
        dots.forEach((d, i) => d.setAttribute('aria-current', i === step ? 'step' : 'false'));
        lastStep = step;
      }
    };
    const queue = () => {
      if (!queued) {
        queued = true;
        requestAnimationFrame(update);
      }
    };
    if (lenis) lenis.on('scroll', queue);
    // capture: fängt auch das Scrollen von .page-wrapper ab (Scroll-Ereignisse steigen nicht auf)
    document.addEventListener('scroll', queue, { capture: true, passive: true });
    window.addEventListener('resize', queue);
    update();

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        const r = track.getBoundingClientRect();
        scrollToY(scrollTopNow() + r.top - stickyTop() + span() * (steps.length > 1 ? i / (steps.length - 1) : 0));
      });
    });
  });

  /* Produkt-Navigation: aktiven Bereich markieren */
  const navLinks = [...document.querySelectorAll('.cz-localnav__links a[href^="#"]')];
  if (navLinks.length && 'IntersectionObserver' in window) {
    const byId = new Map(navLinks.map((a) => [a.getAttribute('href').slice(1), a]));
    const navIo = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          navLinks.forEach((a) => a.removeAttribute('aria-current'));
          const link = byId.get(entry.target.id);
          if (link) link.setAttribute('aria-current', 'true');
        });
      },
      { rootMargin: '-45% 0px -50% 0px' }
    );
    byId.forEach((_, id) => {
      const target = document.getElementById(id);
      if (target) navIo.observe(target);
    });
  }

  /* Galerie im Kaufbereich: Vorne / Hinten */
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cz-show]');
    if (!button) return;
    const gallery = button.closest('[data-cz-gallery]');
    if (!gallery) return;
    const index = button.dataset.czShow;
    gallery.querySelectorAll('[data-cz-show]').forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
    gallery.querySelectorAll('.cz-buy__img').forEach((img, i) => img.classList.toggle('is-active', String(i) === index));
  });

  /* Karussell „Gut zu wissen“: Pfeile und Zustand */
  document.querySelectorAll('[data-cz-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('.cz-reasons__track');
    const prev = carousel.querySelector('[data-cz-prev]');
    const next = carousel.querySelector('[data-cz-next]');
    if (!track || !prev || !next) return;
    const step = () => {
      const card = track.querySelector('.cz-card');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 20;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    };
    const sync = () => {
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };
    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }));
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });
})();
